import { useEffect, useState } from "react"

const KEY = "install-hint-dismissed-v1"
const IOS_UA = /iPhone|iPad|iPod/i

export function InstallHint() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return
    if (localStorage.getItem(KEY)) return
    const isIOS = IOS_UA.test(navigator.userAgent)
    const inStandalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      (navigator as unknown as { standalone?: boolean }).standalone === true
    if (isIOS && !inStandalone) setShow(true)
  }, [])

  if (!show) return null
  const dismiss = () => {
    localStorage.setItem(KEY, "1")
    setShow(false)
  }
  return (
    <div className="install-hint" role="status">
      Zainstaluj: <strong>Udostępnij ▸ Do ekranu początkowego</strong>.
      <button className="close" onClick={dismiss} aria-label="Zamknij">
        ×
      </button>
    </div>
  )
}
